import {
  FETAL_SEX_CODE_RESULT,
  FetalSexCodeResult,
  STANDALONE_FETAL_SEX,
  StandaloneFetalSex,
} from "../../../recoil/types";

const legacyFetalSexCodeResults = Object.values(FETAL_SEX_CODE_RESULT);

const isLegacyFetalSexCodeResult = (
  value: string,
): value is FetalSexCodeResult =>
  (legacyFetalSexCodeResults as readonly string[]).includes(value);

/*
 * External reveal links encode fetal sex directly in the URL, so already-sent
 * email links cannot be repaired by backend normalization. Keep this exhaustive
 * legacy FetalSexCodeResult -> StandaloneFetalSex compatibility map isolated so
 * it is easy to delete when old email links no longer need to resolve.
 */
const standaloneFetalSexByLegacyFetalSexCodeResult = {
  [FETAL_SEX_CODE_RESULT.MALE]: STANDALONE_FETAL_SEX.MALE,
  [FETAL_SEX_CODE_RESULT.FEMALE]: STANDALONE_FETAL_SEX.FEMALE,
  [FETAL_SEX_CODE_RESULT.MALE_MALE]: STANDALONE_FETAL_SEX.MALE_MALE,
  [FETAL_SEX_CODE_RESULT.FEMALE_FEMALE]: STANDALONE_FETAL_SEX.FEMALE_FEMALE,
  [FETAL_SEX_CODE_RESULT.MALE_FEMALE]: STANDALONE_FETAL_SEX.MALE_FEMALE,
  [FETAL_SEX_CODE_RESULT.ONE_OR_BOTH_MALES]:
    STANDALONE_FETAL_SEX.ONE_OR_BOTH_MALES,
  [FETAL_SEX_CODE_RESULT.NO_RESULT]: undefined,
  [FETAL_SEX_CODE_RESULT.NO_CALL]: STANDALONE_FETAL_SEX.NO_CALL,
  [FETAL_SEX_CODE_RESULT.NOT_REPORTED]: STANDALONE_FETAL_SEX.NOT_REPORTED,
  [FETAL_SEX_CODE_RESULT.NOT_ORDERED]: undefined,
  [FETAL_SEX_CODE_RESULT.ORDERED]: undefined,
  [FETAL_SEX_CODE_RESULT.PROCESSING]: undefined,
  [FETAL_SEX_CODE_RESULT.NA]: undefined,
  [FETAL_SEX_CODE_RESULT.EMPTY]: undefined,
  [FETAL_SEX_CODE_RESULT.NO_VALUE_PROVIDED]: undefined,
} satisfies Record<FetalSexCodeResult, StandaloneFetalSex | undefined>;

export const parseLegacyExternalFetalSexEmailValue = (
  value: string,
): StandaloneFetalSex | undefined => {
  if (!isLegacyFetalSexCodeResult(value)) {
    return undefined;
  }
  return standaloneFetalSexByLegacyFetalSexCodeResult[value];
};
